/* app_alma.js — le widget Alma sous le prix, sur DESKTOP seulement.

   ⛔ Sur mobile, ne rien déplacer. La fiche mobile range ses blocs par `order:`
   (`assets/section-main-product.css`, bloc « l'ordre de Thomann ») ; déplacer Alma DANS
   `.product__block--price` en fait un ENFANT du prix au lieu d'un frère, et plus aucune
   règle d'ordre ne peut le descendre sous le bouton d'achat. C'est ce qui le gardait
   collé au prix après la remontée du groupe d'achat du 21/09.

   Le déplacement ne sert que le desktop : `assets/app_alma.css` ne met le bloc prix en
   `display: flex` / `justify-content: space-between` qu'en `@media (min-width: 769px)`.
   Sous 768 px il ne reste que `#alma-widget { justify-content: flex-start }`, qui ne
   dépend pas du parent.

   Le seuil est celui du CSS d'Alma (769 px), pas celui de l'ordre mobile (768 px) : le
   déplacement doit suivre la mise en flex, c'est elle qu'il sert.

   La position d'origine est mémorisée au premier passage pour que le retour en arrière
   soit possible si la fenêtre repasse sous le seuil. */
(function () {
  var desktop = window.matchMedia('(min-width: 769px)');
  var origines = new WeakMap();

  function placer() {
    var prix = document.querySelector(
      '.product__info-wrapper .product__block.product__block--price'
    );
    document.querySelectorAll('.alma_widget_block').forEach(function (widget) {
      var bloc = widget.closest('.product__block--\\@app');
      if (!bloc || !prix) return;
      if (!origines.has(bloc)) {
        origines.set(bloc, { parent: bloc.parentNode, suivant: bloc.nextSibling });
      }
      if (desktop.matches) {
        if (bloc.parentNode !== prix) prix.appendChild(bloc);
        return;
      }
      var origine = origines.get(bloc);
      if (!origine.parent || bloc.parentNode === origine.parent) return;
      var repere = origine.suivant;
      if (repere && repere.parentNode !== origine.parent) repere = null;
      origine.parent.insertBefore(bloc, repere);
    });
  }

  placer();
  desktop.addEventListener('change', placer);
})();
